import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { PREMIUM_MAIN_PAGE } from "utils/constants/paths";

const PremiumMainPage = Loadable(React.lazy(() => import("./View")));

export const PremiumMainPageRoute: IRouteItem = {
  path: PREMIUM_MAIN_PAGE,
  element: React.createElement(PremiumMainPage),
  name: "Premium ",
};
